import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { Analytics } from '@vercel/analytics/react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import App from './App.tsx';
import './index.css';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

// Native scroll only. The site previously ran Lenis smooth-scroll wrapped
// through GSAP's ticker, but the interpolation fought the browser's own
// scrolling — the extra catch-up frame read as sluggish on the wheel and
// glitchy at the hero → About handoff. ScrollTrigger listens to the native
// scroll position directly, so removing Lenis makes every scrub track the
// real scroll 1:1 and drops a per-frame rAF + a full-document scroll
// listener off the hot path. Anchor navigation falls back to native
// `scrollIntoView({ behavior: 'smooth' })` in scrollToSection / goHome, and
// modal/carousel scroll-locks now toggle `document.body` overflow directly
// (see ContactFormModal), so nothing depends on a
// window.__lenis handle anymore.

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
      {/* Vercel Speed Insights: cookieless real-user Core Web Vitals, sent
          same-origin to /_vercel/speed-insights. Disclosed on /privacy +
          /cookies. No-ops outside a Vercel deployment. */}
      <SpeedInsights />
      {/* Vercel Web Analytics: cookieless page views, sent same-origin to
          /_vercel/insights. Disclosed on /privacy + /cookies. No-ops outside
          a Vercel deployment. (Vite + React, so the /react entry, not /next.) */}
      <Analytics />
    </BrowserRouter>
  </StrictMode>,
);
